import * as userService from 'services/user';
import { SectionTitle, useCompanyFormState } from '../common';
import { useState } from 'react';
import { CompanyBadgesField } from '../fields'
import AccountTreeTwoToneIcon from '@material-ui/icons/AccountTreeTwoTone';
import { green } from '@material-ui/core/colors';
import { Divider, Grid, Tooltip } from '@material-ui/core';
import { useFormContext, useWatch } from 'react-hook-form';
// import { CompanyServiceField } from '../fields';
import { useRecentGetter } from '@lib/common';
import { useSubject } from '@lib/common/hooks/use-subject';
import { useSubscription } from '@lib/common/hooks/use-subscription';
import { useEffect } from 'react';
import { debounceTime, filter, pairwise, map, startWith } from 'rxjs/operators';
// import { useInsightActions } from '../service-insights';
import { CompanyMasters } from '@api/masters';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import LockClosedIcon from '@material-ui/icons/Lock';
import Fab from '@material-ui/core/Fab';
import styled from 'styled-components';
import { VerifiedDetails } from './section-utils';

export const SectionBadges = () => {
  const { control } = useFormContext();
  const form = useFormContext();
  // const { content } = useCompanyFormState();
  const { user } = userService.useUser();
  const [isLock, setLock] = useState(
    // (content &&
    //   content.verified_sections &&
    //   content.verified_sections.badges_section &&
    //   content.verified_sections.badges_section.verified) ||
      false
  );
  const watchOnVerifiedSections = form.watch('verified_sections');
  const verifiedBy =
    watchOnVerifiedSections &&
    watchOnVerifiedSections.badges_section &&
    watchOnVerifiedSections.badges_section.verified_by;
  const verifiedAt =
    watchOnVerifiedSections &&
    watchOnVerifiedSections.badges_section &&
    watchOnVerifiedSections.badges_section.verified_at + ' IST';

  return (
    <>
      <Grid container spacing={2} justify="space-between">
        <Grid item>
          <SectionTitle
            id="content-badges"
            title="Content Badges"
            subTitle="Information about Content Badges"
            icon={sectionIcon}
          />
        </Grid>
        <Grid item style={{ paddingBottom: '10px' }}>
          <Tooltip
            title={
              isLock ? (
                <>
                  {`Verified by ${verifiedBy}`}
                  <br />
                  {`Verified at ${verifiedAt}`}
                </>
              ) : (
                'Click to Lock the Section'
              )
            }>
            {isLock ? (
              <StyledFab
                color="primary"
                aria-label="add"
                style={{ backgroundColor: 'green' }}
                size="small"
                onClick={() => {
                  setLock(false);
                  form.setValue('verified_sections', {
                    ...form.watch('verified_sections'),
                    badges_section: { verified: false, verified_by: null, verified_at: null,isLockApplied: false },
                  });
                }}>
                <LockClosedIcon />
              </StyledFab>
            ) : (
              <StyledFab
                color="primary"
                aria-label="add"
                style={{ backgroundColor: 'red' }}
                size="small"
                onClick={() => {
                  setLock(true);
                  form.setValue('verified_sections', {
                    ...form.watch('verified_sections'),
                    badges_section: {
                      verified: true,
                      verified_by: user.vtr_id,
                      verified_at: new Date().toLocaleString('en-US', { timeZone: 'IST' }),
                      isLockApplied: true,
                    },
                  });
                  // company.verified_sections.profile_section.verified_by = user.vtr_id;
                  // company.verified_sections.profile_section.verified = true;
                }}>
                <LockOpenIcon />
              </StyledFab>
            )}
          </Tooltip>
          {isLock && <VerifiedDetails verifiedBy={verifiedBy} verifiedAt={verifiedAt} />}
        </Grid>
      </Grid>

      <Divider />
      <br />
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <CompanyBadgesField control={control} name="company_badges" />
        </Grid>
      </Grid>
    </>
  );
};

const sectionIcon = <AccountTreeTwoToneIcon fontSize="large" style={{ color: green[600] }} />;

const StyledFab = styled(Fab)`
  &.MuiFab-sizeSmall {
    width: 40px;
    // height: 30px;
  }
  & .MuiSvgIcon-root {
    font-size: 1.4rem;
  }
`;
